import { Dispatch } from "@reduxjs/toolkit";
import H from "history";
import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { PremiumOffersFilterType } from "redmond";
import { FTCPricingUpdateVariantType } from "../../context/experiments";
import { IStoreState } from "../../reducers/types";
import { actions as availabilityActions } from "../availability/actions";
import {
  getIsVentureX,
  getRewardsAccountWithLargestEarnForBanner,
  getSelectedAccountIndex,
} from "../rewards/reducer";
import { actions } from "./actions";
import { PremiumCollectionOffers } from "./component";
import { SortOption } from "./reducer";
import {
  getSelectedFilterCategory,
  getSelectedSortOption,
  getOffersState,
  getFTCPricingUpdateVariant,
} from "./reducer/selectors";

const mapStateToProps = (state: IStoreState) => ({
  offersState: getOffersState(state),
  selectedSortOption: getSelectedSortOption(state),
  rewardsAccount: getRewardsAccountWithLargestEarnForBanner(state),
  isVentureX: getIsVentureX(state),
  selectedFilterCategory: getSelectedFilterCategory(state),
  ftcPricingUpdateVariant: getFTCPricingUpdateVariant(state),
  selectedAccountIndex: getSelectedAccountIndex(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchPremiumOffersShop: (
    history: H.History,
    params: IOfferAvailabilityRequest
  ) => dispatch(actions.fetchPremiumOffersShop(history, params)),
  setSelectedLodgingIndex: (index: number) =>
    dispatch(availabilityActions.setSelectedLodgingIndex(index)),
  setOffersSort: (sort: SortOption) => dispatch(actions.setOffersSort(sort)),
  setIsUserTriggeredSearch: (isUserTriggeredSearch: boolean) =>
    dispatch(actions.setIsUserTriggeredSearch(isUserTriggeredSearch)),
  setSelectedFilterCategory: (value: PremiumOffersFilterType) =>
    dispatch(actions.setSelectedFilterCategory(value)),
  setFTCPricingUpdateVariant: (variant: FTCPricingUpdateVariantType) =>
    dispatch(actions.setFTCPricingUpdateVariant(variant)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PremierCollectionAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPremiumCollectionOffers = withRouter(
  connector(PremiumCollectionOffers)
);
